import { render } from "./SoapberryBraceletPage.vue?vue&type=template&id=eece9398&scoped=true"
import script from "./SoapberryBraceletPage.vue?vue&type=script&lang=js"
export * from "./SoapberryBraceletPage.vue?vue&type=script&lang=js"

import "./SoapberryBraceletPage.vue?vue&type=style&index=0&id=eece9398&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eece9398"]])

export default __exports__